module.exports = __webpack_public_path__ + "img/box4-active1.57bde761.png";